import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const EmptyInputsStyled = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: 450px;
  padding: 20px;

  background: transparent;
`;

export const PlaceholderImage = styled.img`
  height: 240px;
  width: 433px;
  margin: 36px 0;
  align-self: center;
`;

export const TitleText = styled.label`
  font-size: 22px;
  line-height: 30px;
  color: ${TextColorNames.primary};
  font-family: inherit;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DescriptionText = styled.label`
  width: 100%;
  max-width: 600px;
  font-size: 14px;
  line-height: 20px;
  color: ${TextColorNames.tertiary};
  text-align: center;
  font-family: inherit;
  font-weight: 500;
  text-overflow: ellipsis;
`;
